
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import Index from "./pages/Index";
import MyTrainingResources from "./pages/MyTrainingResources";
import Account from "./pages/Account";

// Create a client with more resilient settings
const createQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 300000, // 5 minutes
    },
  },
});

const App = () => {
  // Reset the query client if needed due to errors
  const [queryClient, setQueryClient] = useState(() => createQueryClient());
  
  // Check for Firebase errors and disable Firebase
  useEffect(() => {
    const handleWindowError = (event: ErrorEvent) => {
      const errorText = event.message || '';
      if (
        errorText.includes('firebase') || 
        errorText.includes('firestore') ||
        errorText.includes('Failed to fetch')
      ) {
        console.warn('Firebase/network error detected, resetting query client');
        // Reset query client on firebase errors
        setQueryClient(createQueryClient());
      }
    };

    window.addEventListener('error', handleWindowError);
    return () => window.removeEventListener('error', handleWindowError);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/training" element={<MyTrainingResources />} />
            <Route path="/training/:resourceId" element={<MyTrainingResources />} />
            <Route path="/resource/:resourceId" element={<MyTrainingResources />} />
            <Route path="/account" element={<Account />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
